import React from 'react'
import { isAndroid, isIOS } from 'react-device-detect'
import { Row, Col, Button, Typography } from 'antd';
import '../../style/style.css'


const ChooseDevicePage = () => {
    const { Text } = Typography;

    const handleToDowload = () => {
        if (isIOS) {
            window.location = `https://apps.apple.com/th/app/virtual-connect/id1503974336`
        } else if (isAndroid) {
            window.location = `https://play.google.com/store/apps/details?id=com.truecorp.vconnect`
        } else {
            window.location = window.location.origin
        }
    }

    const handleToWeb = () => {
        if(isIOS){
            window.location.href = `fb691636491587233://`
        }else if(isAndroid){
            window.location.href = `intent://vroom.truevirtualworld.com#Intent;scheme=com.truecorp.vconnect;package=com.truecorp.vconnect;end`
        }else{
            window.location = window.location.origin
        }

    }
    return (
        <>
            <Row type="flex" justify="center" className="mobile-header" align="middle">
                <Col span={10}>
                    {/* eslint-disable-next-line */}
                    <img src={process.env.PUBLIC_URL + '/img/logo-deep-linking.png'} />
                </Col>
            </Row>
            <Row type="flex" justify="center" align="middle" className="text-dowload-app">
                <Col lg={24} md={24} sm={24} xs={24}>
                    <Text strong>เพื่อประสิทธิภาพในการใช้งานผ่าน Mobile กรุณาใช้งานผ่านแอปพลิเคชั่น True VROOM</Text>
                </Col>
            </Row>
            <Row type="flex" justify="center" align="middle" className="group-download-app" >
                <Col lg={6} md={12} sm={12} xs={12} >
                    <Button className="btn-download-app btn-download" onClick={handleToDowload}>Download the app</Button>
                </Col>
            </Row>
            <Row type="flex" justify="center" align="middle" className="group-download-app">
                <Col lg={6} md={10} sm={12} xs={12}>
                    <Button className="btn-download-app btn-continue" onClick={handleToWeb}>Continue to the app</Button>
                </Col>
            </Row>
        </>
    )
}

export default ChooseDevicePage